export const ColorsConst = {
  white: '#ffffff',
  primary: '#1890FF',
  darkGrey: '#1b1b1b',
  grey: '#ebebeb',
  greyBorder: '#f0f0f0',
  success: '#52c41a',
  warning: '#faad14',
  danger: '#ff4d4f',
  facebook: '#4267b2',
  facebookMessenger: '#0078ff',
  whatsapp: '#25d366',
  twitter: '#1da1f2',
  instagram: '#c13584',
  snapchat: '#fffc00',
  youtube: '#ff0000',
  overcapacity: '#f5222d',
  spotify: '#1db954',
  deezer: '#2d96c8',
  netflix: ' #e50914',
};
